"use client";

import { createContext, useContext } from "react";
import type { TooltipData } from "./chart-context";

export type ScatterProjectionLayout = "lanes" | "floor";

export interface ScatterProjectionValue {
  slots: ReadonlyMap<number, SVGGElement>;
  lanes: number;
  laneDepth: number;
  layout: ScatterProjectionLayout;
  pillarExtent: number;
  pillarFootprint: number;
  pointInteraction: boolean;
  interactive: boolean;
  enter: (tooltip: TooltipData, key: string) => void;
  leave: () => void;
  tap: (tooltip: TooltipData, key: string) => void;
}

export const scatterLane = (series: number, seriesCount: number): number =>
  Math.max(1, seriesCount) - 1 - series;

export const scatterFloorSlot = (
  row: number,
  series: number,
  seriesCount: number
): number => row * Math.max(1, seriesCount) + series;

const ScatterProjectionContext = createContext<ScatterProjectionValue | null>(
  null
);

export const ScatterProjectionProvider = ScatterProjectionContext.Provider;

export function useScatterProjection(): ScatterProjectionValue | null {
  return useContext(ScatterProjectionContext);
}
